import { imageMapping } from '@model/components/imageCrop.model'
const default_position = {
  top: "0",
  left: "0",
  height: "0",
  width: "0",
}

const state = {
  componentID: undefined,
  componentType: undefined,
  position: default_position,
  demoActiveAnimation: null,
}
const getters = {
  imageCropPosition: state => {
    return state.position
  },
  imageCropComponentID: state => {
    return state.componentID
  },
  imageCropMapping: state => {
    return imageMapping(state.componentType)
  },
  demoActiveAnimation: state => {
    return state.demoActiveAnimation
  },
}
const actions = {
  setImageCrop({ commit, dispatch, rootGetters }, { componentID }) {
    const components = rootGetters['designIframe/metadata/components']
    const siteComponents = rootGetters['designIframe/metadata/siteComponents']
    const isSiteComponent = Object.prototype.hasOwnProperty.call(siteComponents, componentID)
    const type = isSiteComponent ? siteComponents[componentID].type : components[componentID].type
    if (imageMapping(type)) {
      
      let elementID ='';
      
      switch(componentID){
        case 'HEADER_AREA': elementID = 'top-area';
        break;
        case 'FOOTER_AREA': elementID = 'footer-area';
        break;
        default : elementID = `comp-${componentID}`;
        break;
      }

      const element = document.getElementById(elementID)
      const scrollTop = document.getElementsByTagName("html")[0].scrollTop
      const rect = element.getBoundingClientRect()
      const position = {
        top: parseInt(rect.top + scrollTop),
        height: parseInt(rect.height),
        left: parseInt(rect.left),
        width: parseInt(rect.width),
      }
      commit('SET_IMAGE_CROP', { position, componentID, type })
    } else {

      dispatch('design/toast', {
        title: "Oops!",
        desc: `this component doesn't mapping schema`,
        varaint: "danger"
      }, { root: true })

    }

  },
  closeImageCrop({ commit, dispatch }) {
    commit('SET_IMAGE_CROP', {})
    dispatch("design/setMode", {}, { root: true })
  },
  showImageAnimation({ commit }, type) {
    commit('SET_IS_ACTIVE_ANIMATION', type)
  },
  hideImageAnimation({ commit }) {
    commit('SET_IS_ACTIVE_ANIMATION', null)
  },
}
const mutations = {
  SET_IMAGE_CROP(state, { position, componentID, type }) {
    state.componentType = type;
    state.position = position;
    state.componentID = componentID;
  },
  SET_IS_ACTIVE_ANIMATION(state, value) {
    state.demoActiveAnimation = value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};